// English message catalogue: one namespace per file under ./en. Screen namespaces are
// named after the screen ID, so a wave-2 worker only touches their own file.
import common from './en/common';
import type S0b from './en/S0b';
import type S1 from './en/S1';
import type S2 from './en/S2';
import type S3 from './en/S3';
import type S3manual from './en/S3-manual';
import type S4 from './en/S4';
import type S5 from './en/S5';
import type S6 from './en/S6';
import type S6stop from './en/S6-stop';
import type S7 from './en/S7';
import type S8 from './en/S8';
import type S9 from './en/S9';
import type S10 from './en/S10';
import type S11 from './en/S11';
import type S11handoff from './en/S11-handoff';
import type S12 from './en/S12';
import type S13 from './en/S13';
import type S14expired from './en/S14-expired';
import type S15 from './en/S15';
import type consent from './en/consent';

export interface Catalogue {
  common: typeof common;
  S0b: typeof S0b;
  S1: typeof S1;
  S2: typeof S2;
  S3: typeof S3;
  'S3-manual': typeof S3manual;
  S4: typeof S4;
  S5: typeof S5;
  S6: typeof S6;
  'S6-stop': typeof S6stop;
  S7: typeof S7;
  S8: typeof S8;
  S9: typeof S9;
  S10: typeof S10;
  S11: typeof S11;
  'S11-handoff': typeof S11handoff;
  S12: typeof S12;
  S13: typeof S13;
  'S14-expired': typeof S14expired;
  S15: typeof S15;
  /** The cookie banner (chrome/consent), registered when its chunk loads. */
  consent: typeof consent;
}

/**
 * The English catalogue as loaded so far: `common` (the chrome) is always here; each stage
 * chunk registers its screens' namespaces when it loads (app/stages/*.ts), so a visit only
 * downloads the copy of the stages it opens.
 */
export const en = { common } as Pick<Catalogue, 'common'> & Partial<Catalogue>;

/** A stage chunk adds its namespaces (`registerMessages({ S7, S8 })`). */
export function registerMessages(namespaces: Partial<Catalogue>): void {
  Object.assign(en, namespaces);
}

export type Namespace = keyof Catalogue;
/** Every key as `namespace.key`, e.g. `common.back`, `S1.title`, `S3-manual.title`. */
export type MessageKey = {
  [N in Namespace]: `${N}.${Extract<keyof Catalogue[N], string>}`;
}[Namespace];
